// FIFO per-owner turns: claims can run between Auto rounds, never racing the
// revision used to submit a wager. Server CAS/idempotency remain authoritative.
const turns = new Map();
export const withWalletTurn = async (owner, operation) => {
  if (!owner || owner === 'demo') return operation();
  const before = turns.get(owner) || Promise.resolve();
  let release;
  const next = new Promise((resolve) => { release = resolve; });
  turns.set(owner, next);
  await before;
  try { return await operation(); }
  finally {
    release();
    if (turns.get(owner) === next) turns.delete(owner);
    window.dispatchEvent(new CustomEvent('gv-wallet-turn-finished', { detail: { user_id: owner } }));
  }
};

export const publishClaimWallet = (owner, result) => window.dispatchEvent(new CustomEvent('gv-wallet-updated', {
  detail: { ...result, user_id: owner, safe_claim_turn: true },
}));